export const FETCH_QUIZZES_START = 'FETCH_QUIZZES_START'
export const FETCH_QUIZZES_SUCCESS = 'FETCH_QUIZZES_SUCCESS'
export const FETCH_QUIZZES_ERROR = 'FETCH_QUIZZES_ERROR'
export const FETCH_QUIZ_SUCCESS = 'FETCH_QUIZ_SUCCESS'
export const SET_ANSWER_STATE = 'SET_ANSWER_STATE'
export const FINISHED_QUIZ = 'FINISHED_QUIZ'
export const NEXT_QUESTION = 'NEXT_QUESTION'
export const CLEAR_QUIZ = 'CLEAR_QUIZ'
export const CLEAR_QUIZ_CREATION = 'CLEAR_QUIZ_CREATION'
export const ADD_QUESTION = 'ADD_QUESTION'
export const ADD_TITLE = 'ADD_TITLE'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'